<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">
                        Edit Player Stats
                    </div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style="" to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style="" to="/admin/players_stats" v-bind:exact="exact">Players Stats</v-breadcrumbs-item>
                        <v-breadcrumbs-item style disabled>Edit Player Stats</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-form ref="form" v-model="valid">
                            <v-card-text>
                                <v-select
                                    v-model="seasonId"
                                    v-bind:items="seasons"
                                    label="Season"
                                    readonly
                                ></v-select>
                                <v-select
                                    v-model="playerId"
                                    v-bind:items="players"
                                    label="Players"
                                    readonly
                                ></v-select>
                                <v-select
                                    v-model="teamId"
                                    v-bind:items="teams"
                                    label="Teams"
                                    readonly
                                ></v-select>
                            </v-card-text>
                            <v-card-text>
                                <v-subheader>Hitting Stats</v-subheader>
                                <v-divider class="mb-3"></v-divider>
                                <v-text-field
                                    name="hr"
                                    label="Home Runs"
                                    v-model="hr"
                                    mask="###"
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text>
                                <v-subheader>Pitching Stats</v-subheader>
                                <v-divider class="mb-3"></v-divider>
                                <v-text-field
                                    name="ip"
                                    label="Innings Pitched"
                                    v-model="ip"
                                    mask="###"
                                ></v-text-field>
                                <v-text-field
                                    name="so"
                                    label="Strikeouts"
                                    v-model="so"
                                    mask="###"
                                ></v-text-field>
                                <v-divider></v-divider>
                                <v-checkbox
                                    label="Playoff Stat?"
                                    v-model="isPlayoffStat"
                                    type="checkbox"
                                ></v-checkbox>
                            </v-card-text>
                        </v-form>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-bind:disabled="!valid"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                            >Update Player Stats</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

export default {
    name: 'AdminPlayersStatsEdit',
    props: ['id'],
    data() {
        return {
            exact: true,
            valid: false,
            seasonId: '',
            playerId: '',
            teamId: '',
            hr: 0,
            ip: 0,
            so: 0,
            isPlayoffStat: false
        }
    },
    mounted() {
        let player_stats = this.$store.getters.getPlayerStatsById(this.id)

        this.seasonId = player_stats.season_id
        this.playerId = player_stats.player_id
        this.teamId = player_stats.team_id
        this.hr = player_stats.hr
        this.ip = player_stats.ip
        this.so = player_stats.so

        if (player_stats.hasOwnProperty('is_playoff_stat')) {
            if (player_stats.is_playoff_stat) {
                this.isPlayoffStat = true
            }
            else {
                this.isPlayoffStat = false
            }
        }
        else {
            this.isPlayoffStat = false
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('updatePlayerStats', {
                    id: this.id,
                    hr: parseInt(this.hr),
                    ip: parseInt(this.ip),
                    so: parseInt(this.so),
                    is_playoff_stat: this.isPlayoffStat
                })
            }
        }
    },
    computed: {
        seasons() {
            return this.$store.state.seasons
                .map((season) => {
                    return { text: season.season, value: season.id }
                })
                .sort((a, b) => {
                    if (a.text > b.text) {
                        return -1
                    } else if (a.text < b.text) {
                        return 1
                    } else {
                        return 0
                    }
                })
        },
        players() {
            let players = this.$store.getters.getPlayersSortedByLastName

            let players_items = []

            players.forEach((player) => {
                if (player) {
                    let full_name = this.$store.getters.getPlayerFullNameById(player.id)
                    players_items.push({ text: full_name, value: player.id })
                }
            })

            return players_items
        },
        teams() {
            let teams = this.$store.getters.getMatchTeams

            let teams_items = []

            teams.forEach((team) => {
                if (team) {
                    teams_items.push({ text: team.team, value: team.id })
                }
            })

            return teams_items
        }
    }
}
</script>

<style scoped></style>
